import { render } from "./StatsList.vue?vue&type=template&id=5a95d8e8"
import script from "./StatsList.vue?vue&type=script&lang=js"
export * from "./StatsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__